import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { IConvo } from '../../../model/convo'
import fetchCreator from './fetch-creator'
import fetchTags from './fetch-tags'
import fetchReferences from './fetch-references'
import fetchReactions from './fetch-reactions'
import fetchStatements from './fetch-statements'
import fetchComments from './fetch-comments'

export default async function setMeta(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
    // convoStore.commitInitMeta({ convoId: convo.id })
    fetchCreator(context, convo)
    fetchReactions(context, convo)
    fetchReferences(context, convo)
    fetchTags(context, convo)
    fetchStatements(context, convo)
    fetchComments(context, convo)
    return
}
